<div class="agpr-formField">
    <agpr-dropdown
        placeholder="Reports.prominence.subject.placeholder"
        ariaLabel="Reports.prominence.subject.placeholder"
        [options]="prominenceGroups"
        [(ngModel)]="selectedProminenceGroup"
        (ngModelChange)="setGroupId()"
        [disabled]="disabled"
        [ariaLabelledBy]="field.headingId"
    >
    </agpr-dropdown>
</div>
